module.exports = __webpack_public_path__ + "fonts/RenaultLife-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Light.woff
// module id = 360
// module chunks = 0